import { render } from "./tenantAllowances.vue?vue&type=template&id=022b0324&ts=true"
import script from "./tenantAllowances.vue?vue&type=script&lang=ts"
export * from "./tenantAllowances.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__